











































































































































































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Inject, Watch } from "vue-property-decorator";
import { ModelState } from "@elite/validation";
import { RestClient, RestResponse } from "@elite/restclient";
import { IPromotionModel } from "../models";
import { ISelectListItem } from "@everbright/promotions/lib/models";
import { PromotionManagementRoute, EditPromotionRoute } from "../router";
import IView from "./IView";
import PromotionManagementEvents from "../components/promotionManagement/PromotionManagementEvents";

@Component
export default class AddEditPromotion extends Vue implements IView {
    @Inject()
    restClient!: RestClient;

    @Inject()
    modelState!: ModelState;

    @Prop({ type: Number, default: null })
    id?: number;

    @Prop({ required: true })
    title!: string;

    @Prop({ required: false, default: false })
    syncOnLoad!: boolean;

    isLoading = false;
    model: IPromotionModel | null = null;
    campaignItems: ISelectListItem[] = [];
    campaignPromotionItems: ISelectListItem[] = [];
    syncChanges = [];

    get cancelPath() {
        return PromotionManagementRoute.path;
    }

    @Watch("model.campaignCode")
    campaignSelect(value: string, oldValue: string): void {
        // Do not continue on initial load
        if (value === null) {
            return;
        }

        if (this.model && oldValue !== undefined) {
            this.model.defaultPromotionCode = "";
        }

        this.getAdvantageCampaignPromotionItems(value);
    }

    async getAdvantageCampaignPromotionItems(
        campaignCode: string
    ): Promise<void> {
        const url = "/api/Advantage/Promotion/Items";

        await this.restClient
            .postJson<ISelectListItem[]>(url, [campaignCode])
            .then(response => {
                this.campaignPromotionItems = response.data || [];
            });
    }

    async getAdvantageCampaignItems(): Promise<void> {
        await this.restClient
            .getJson<ISelectListItem[]>("/api/Advantage/Campaign/Items")
            .then(response => {
                this.campaignItems = response.data || [];
            });
    }

    mounted() {
        this.getAdvantageCampaignItems();
    }

    @Watch("id", { immediate: true })
    onIdChanged(oldValue: number, newValue: number) {
        this.refreshModel();

        if (this.id && this.id > 0 && this.syncOnLoad) {
            this.sync();
        }
    }

    async refreshModel() {
        if (this.id) {
            const response = await this.restClient.getJson<IPromotionModel>(
                "/api/Promotion/" + this.id
            );

            if (response.status == 200 && response.data) {
                this.model = response.data;
            }
        } else {
            this.model = {
                id: 0,
                name: null,
                campaignCode: null,
                defaultPromotionCode: null,
                slug: null,
                submitOrderButtonText: null,
                contactUsUrl: null,
                backgroundColor: "#ffffff",
                buttonColor: null,
                description: null,
                emailOptInText: null,
                emailOptInRequired: false,
                leftSideTopContent: null,
                leftSideBottomContent: null,
                termsAndConditionsText: null,
                thankYouPageHeaderText: null,
                thankYouPageText: null,
                brand: null,
                brandCustomerServicePhone: null,
                guaranteeText: null,
                localeId: null,

                promotionUrl: null,

                logoImageFileName: null,
                productImageFileName: null,
                thankYouPageImageFileName: null,
                guaranteeImageFileName: null,

                facebookPixelId: null,
                facebookAccessToken: null
            };
        }
    }

    async sync(): Promise<void> {
        const response = await this.restClient.postJson<[]>(
            `/api/Promotion/${this.id}/Sync`,
            {}
        );

        this.syncChanges = response.data || [];

        // refresh both grids
        this.$root.$emit(
            PromotionManagementEvents.promotionItemGridRefreshEvent
        );

        this.$root.$emit(
            PromotionManagementEvents.promotionUpsellGridRefreshEvent
        );
    }

    async saveAndContinue(): Promise<void> {
        await this.save(true);
    }

    async save(saveAndContinue = false): Promise<void> {
        if (!this.model) {
            return;
        }

        this.isLoading = true;

        let response: RestResponse<IPromotionModel>;

        const apiLocation = "/api/Promotion";

        if (this.model.id && this.model.id > 0) {
            response = await this.restClient.putJson<IPromotionModel>(
                apiLocation,
                this.model
            );
        } else {
            response = await this.restClient.postJson<IPromotionModel>(
                apiLocation,
                this.model
            );
        }

        if (this.modelState.hasErrors(response) || !response.data) {
            this.modelState.addResponseErrors(response, this);
        } else {
            if (saveAndContinue == true) {
                alert("Your changes have been saved.");
            } else {
                if (this.model.id && this.model.id > 0) {
                    this.$router.push({
                        path: PromotionManagementRoute.path
                    });
                } else {
                    this.$router.push({
                        name: EditPromotionRoute.name,
                        params: { id: (response.data.id || 0).toString() },
                        query: { sync: true.toString() }
                    });

                    window.scrollTo(0, 0);
                }
            }
        }

        this.isLoading = false;
    }
}
